import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const ApplicationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <g id="Symbols">
          <g id="Icon-_x2F_-Lightning" transform="translate(-7.000000, -2.000000)">
            <path
              id="Path"
              className="st0"
              d="M16.4,24c0,0,6.9-15,6.9-15l0.4-0.9c-1.5,0.4-4.8,1.2-4.8,1.3c0.3-1,1.8-5.4,1.9-5.4
			c-1.4,0-2.9,0-4.3,0l-0.4,2.1l-1.8,7.5l4.8-1.3L16.4,24z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default ApplicationIcon;
